import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import i18n from 'i18next';
import {
  MenuItem,
  InputAdornment,
  IconButton,
  Link,
  Button,
  Typography,
  TextField,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import useTempIEStyles from './useTempIEStyles';

import { regions } from '../../constants/regions';

const useStyles = makeStyles((theme) => ({
  root: {},
  links: {
    '& > * + *': {
      marginLeft: 10,
    },
  },
  margin: {
    margin: theme.spacing(1, 0),
  },
  header: {
    marginBottom: 16,
  },
}));

const LoginForm = ({
  values: { region, email, password },
  errors,
  touched,
  handleSubmit,
  handleChange,
  isValid,
  setFieldTouched,
  validateForm,
  errorMessage = '',
  onChange,
}) => {
  const classes = useStyles();
  const ieStyles = useTempIEStyles();
  const history = useHistory();

  const [values, setValues] = useState({
    showPassword: false,
  });

  const [state] = useState({
    showLoginForm: true,
  });

  const change = async (event) => {
    onChange(event);
    event.persist();
    const target = event.target;

    setFieldTouched(target.id, true, false);
    await handleChange(event);

    if (!isValid) {
      validateForm();
    }
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickRegister = (event) => {
    event.preventDefault();
    history.push('/register');
  };

  const handleClickForgot = (event) => {
    event.preventDefault();
    history.push('/forgot');
  };

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <Typography variant="h2">{i18n.t('login:title')}</Typography>
        <Typography variant="subtitle1">{i18n.t('login:sub')}</Typography>
      </header>
      <form noValidate autoComplete="off" onSubmit={handleSubmit}>
        {errorMessage && (
          <Typography variant="body1" color="error">
            {errorMessage}
          </Typography>
        )}
        <TextField
          id="region"
          name="region"
          size="small"
          variant="outlined"
          className={classes.margin}
          fullWidth
          select
          label={i18n.t('login:form:region')}
          value={region}
          onChange={change}
          helperText={touched.region ? errors.region : ''}
          error={touched.region && Boolean(errors.region)}
        >
          {regions.map((option, index) => (
            <MenuItem
              className={ieStyles.menuItem}
              key={option.label}
              value={option.value}
            >
              {index === 0 ? i18n.t(`regions:${option.label}`) : option.label}
            </MenuItem>
          ))}
        </TextField>
        {state.showLoginForm && (
          <Fragment>
            <TextField
              id="email"
              name="email"
              variant="outlined"
              className={classes.margin}
              margin="dense"
              label={i18n.t('login:form:email:label')}
              fullWidth
              value={email}
              onChange={change}
              helperText={touched.email ? errors.email : ''}
              error={touched.email && Boolean(errors.email)}
            />
            <TextField
              id="password"
              name="password"
              variant="outlined"
              className={classes.margin}
              type={values.showPassword ? 'text' : 'password'}
              margin="dense"
              label={i18n.t('login:form:password:label')}
              fullWidth
              value={password}
              onChange={change}
              helperText={touched.password ? errors.password : ''}
              error={touched.password && Boolean(errors.password)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.margin}
              type="submit"
              disabled={!isValid}
            >
              {i18n.t('login:form:buttons:login')}
            </Button>
          </Fragment>
        )}
        <Typography className={classes.links}>
          <Link href="/forgot" onClick={handleClickForgot}>
            {i18n.t('login:links:forgot')}
          </Link>
          <Link href="/register" onClick={handleClickRegister}>
            {i18n.t('login:links:register')}
          </Link>
        </Typography>
      </form>
    </div>
  );
};

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  isValid: PropTypes.bool,
  touched: PropTypes.shape({}),
  setFieldTouched: PropTypes.func,
  errorMessage: PropTypes.string,
  values: PropTypes.shape({
    region: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
  }),
  errors: PropTypes.shape({}),
  validateForm: PropTypes.func,
  onChange: PropTypes.func,
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.js